import {FulltextSearch} from '@/api/meta/filters';
import {autoImplement} from '@/util';
import moment from 'moment';
import {ApiFile} from './File';


export interface ApiPrice {
  Preiseinheit: number,
  SteuerSchluessel: number,
  MwStSatz: number,
  ListenPreis: number,
  ListenBrutto: number,
  RabattFaehig: string,
  EinheitsPreis: number,
  BruttoPreis: number,
  Netto: number,
  MwSt: number,
  Brutto: number,
  SonderPreis: string,
  SollPreis: number,
  SollPreisProvision: unknown | null,
  EinkaufPreis: unknown | null,
  BruttoBerechnung: unknown | null,
  KalkulationKosten: unknown | null,
  SonderherstellungZuschlagPreis: unknown | null,
  BerechnungArt: string
}

export interface ApiPosition {
  AuftragNr: number,
  PosNr: number,
  Art: string,
  ArtikelNr: string,
  ArtikelArt: string,
  ArtikelBezeichnung1: string,
  ArtikelBezeichnung2: string,
  Langtext: string,
  ArtikelTextFix: null,
  Niederlassung: number,
  Lagerhalle: number,
  Lagerfach: number,
  Kostenstelle: number,
  Erloeskonto: number,
  Menge: number,
  BisherigeLiefermenge: number,
  AuftragMindestMenge: unknown | null,
  EinheitSchluessel: number,
  Einheit: string,
  Gewicht: number,
  GewichtNetto: unknown | null,
  LadungsGewicht: unknown | null,
  PosNrVon: unknown | null,
  PosNrBis: unknown | null,
  Kommentar: string,
  InfoVerladung: string,
  Pauschal: string,
  Nabi: unknown | null,
  LaborMusterNr: unknown | null,
  PicklisteNr: unknown | null,
  AuftragBelegNr: unknown | null,
  BestellNrLieferant: unknown | null,
  BestellPositionLieferant: unknown | null,
  PE1Stamm: unknown | null,
  DigisPositionTyp: unknown | null,
  SchnittstelleExport: unknown | null,
  Chargenaufteilung: boolean,
  SerienNr: unknown | null
  Preis?: ApiPrice
}

export interface ApiTask {
  AuftragNr: number,
  Datum: string,
  UhrZeit: string | null,
  GueltigBis: string | null,
  Bediener: string,
  Vertreter: string,
  Vertreter2: string | null,
  Kostenstelle: number,
  Niederlassung: number,
  Erledigt: 'J' | 'N',
  KundenNr: number,
  DebitorKonto: number,
  Kundname: string,
  RechnungHauptkunde: string | null,
  Positionen?: ApiPosition[],
  Archiv?: { Values: ApiFile[] | null },
  Dateien?: { Values: ApiFile[] },
  Unterlagen?: { Values: ApiFile[] }
}

export interface TaskFilters {
  KundenNr?: number;
  AuftragNr?: number;
  Erledigt?: 'J' | 'N';
  Fulltext$Fulltext: FulltextSearch;
}
export interface DetailTaskFilters {
  KundenNr?: number;
  AuftragNr?: number;
}

export default class Task extends autoImplement<ApiTask>() {
  static fromApi(apiTask: ApiTask): Task {
    return new Task(apiTask);
  }

  get color() {
    return this.Erledigt == 'J' ? 'error' : 'success';
  }
  get status() {
    return this.Erledigt == 'J' ? 'error' : 'success';
  }
  get statustext() {
    return this.Erledigt == 'J' ? 'Erledigt' : 'Offen';
  }
  get icon() {
    return this.Erledigt == 'J' ? 'mdi-check' : null;
  }
  get DatumFormatted() {
    return moment(this.Datum).format('DD.MM.YYYY');
  }
}
